import Divider from '@mui/material/Divider';
import { DefaultContext } from '../../Contexts/DefaultContext';
import { ptbr, eng } from '../../Translate';
import { useContext } from 'react';
import './local.css';

function Resume() {
    const { LNG } = useContext(DefaultContext)
    return (
        <div className='resume-main-container'>
            <div className='left-resume-container'>
                <span className='body-left-resume'>
                    <span className='title-resume'>
                        {LNG ? ptbr.expirience.item_1.item_1_1 : eng.experience.item_1.item_1_1}
                    </span>
                    <br />
                    {LNG ? ptbr.expirience.item_1.item_1_2 : eng.experience.item_1.item_1_2}
                    <br />
                    {LNG ? ptbr.expirience.item_1.item_1_3 : eng.experience.item_1.item_1_3}
                    <br />
                    <span className='title-resume'>
                        <b>{LNG ? ptbr.expirience.item_1.item_1_4 : eng.experience.item_1.item_1_4}</b>
                    </span>
                </span>
                <span className='body-left-resume'>
                    <span className='title-resume'>
                        {LNG ? ptbr.expirience.item_2.item_2_1 : eng.experience.item_2.item_2_1}
                    </span>
                    <br />
                    {LNG ? ptbr.expirience.item_2.item_2_2 : eng.experience.item_2.item_2_2}
                    <br />
                    {LNG ? ptbr.expirience.item_2.item_2_3 : eng.experience.item_2.item_2_3}
                    <br />
                    <span className='title-resume'>
                        <b>{LNG ? ptbr.expirience.item_2.item_2_4 : eng.experience.item_2.item_2_4}</b>
                    </span>
                </span>
                <span className='body-left-resume'>
                    <span className='title-resume'>
                        {LNG ? ptbr.expirience.item_3.item_3_1 : eng.experience.item_3.item_3_1}
                    </span>
                    <br />
                    {LNG ? ptbr.expirience.item_3.item_3_2 : eng.experience.item_3.item_3_2}
                    <br />
                    {LNG ? ptbr.expirience.item_3.item_3_3 : eng.experience.item_3.item_3_3}
                    <br />
                    <span className='title-resume'>
                        <b>{LNG ? ptbr.expirience.item_3.item_3_4 : eng.experience.item_3.item_3_4}</b>
                    </span>
                </span>
            </div>
            <Divider orientation="vertical" variant="middle" flexItem />
            <div className='right-resume-container'>
                <span className='body-right-resume'>
                    <span className='title-resume'>
                        {LNG ? ptbr.expirience.item_4.item_4_1 : eng.experience.item_4.item_4_1}
                    </span>
                    <br />
                    {LNG ? ptbr.expirience.item_4.item_4_2 : eng.experience.item_4.item_4_2}
                    <br />
                    {LNG ? ptbr.expirience.item_4.item_4_3 : eng.experience.item_4.item_4_3}
                    <br />
                    <span className='title-resume'>
                        <b>{LNG ? ptbr.expirience.item_4.item_4_4 : eng.experience.item_4.item_4_4}</b>
                    </span>
                </span>
                <span className='body-right-resume'>
                    <span className='title-resume'>
                        {LNG ? ptbr.expirience.item_5.item_5_1 : eng.experience.item_5.item_5_1}
                    </span>
                    <br />
                    {LNG ? ptbr.expirience.item_5.item_5_2 : eng.experience.item_5.item_5_2}
                    <br />
                    {LNG ? ptbr.expirience.item_5.item_5_3 : eng.experience.item_5.item_5_3}
                    <br />
                    <span className='title-resume'>
                        <b>{LNG ? ptbr.expirience.item_5.item_5_4 : eng.experience.item_5.item_5_4}</b>
                    </span>
                </span>
                <span className='body-right-resume'>
                    <span className='title-resume'>
                        {LNG ? ptbr.expirience.item_6.item_6_1 : eng.experience.item_6.item_6_1}
                    </span>
                    <br />
                    {LNG ? ptbr.expirience.item_6.item_6_2 : eng.experience.item_6.item_6_2}
                    <br />
                    {LNG ? ptbr.expirience.item_6.item_6_3 : eng.experience.item_6.item_6_3}
                    <br />
                    <span className='title-resume'>
                        <b>{LNG ? ptbr.expirience.item_6.item_6_4 : eng.experience.item_6.item_6_4}</b>
                    </span>
                </span>
            </div>
        </div>
    );
}

export default Resume;